import styled from 'styled-components';

//miranda tokens
import { getToken } from '@loadsmart/miranda-tokens';
import { screen } from '@/helpers/screen';

export const AwardsList = styled.div`
  margin-top: var(--gap-h2, 56px);
`;

export const AwardsYear = styled.section`
  display: grid;
  grid-template-columns: 1fr;
  gap: 8px;
  padding: 28px 0;
  border-top: 1px solid rgb(${getToken('color-background-tertiary')});

  &:last-child {
    border-bottom: 1px solid rgb(${getToken('color-background-tertiary')});
  }

  ${screen.md} {
    grid-template-columns: 150px minmax(0, 1fr);
    gap: 0 32px;
  }

  /* the year is the row label: large, without the rule GroupLabel draws */
  h3 {
    display: block;
    margin: 0;
    font: 700 32px/1.1 ${getToken('font-family-title')};
    letter-spacing: -0.01em;
    color: rgb(${getToken('color-primary-60')});

    &::after {
      display: none;
    }
  }

  ul {
    margin: 0;
    padding: 0;
    list-style: none;
    font-size: 16px;
    line-height: 1.55;

    ${screen.md} {
      columns: 2;
      column-gap: 48px;
    }
  }

  li {
    position: relative;
    break-inside: avoid;
    padding: 5px 0 5px 18px;
  }

  li::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0.95em;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: rgb(${getToken('color-brand')});
  }

  a {
    color: inherit;
    text-decoration: underline;
    text-underline-offset: 3px;
  }

  a:hover {
    color: rgb(${getToken('color-primary-60')});
  }
`;

export const EarlierRecognition = styled.details`
  margin-top: 32px;

  summary {
    cursor: pointer;
    padding: 10px 0;
    font: 700 16px/1.4 ${getToken('font-family-title')};
    color: rgb(${getToken('color-success-60')});
  }

  ${AwardsList} {
    margin-top: 16px;
  }
`;
